export default "__VITE_ASSET__Bkt$rHnt__"